export default {
  'zh-CN': {
    pleaseEnter: '请输入',
    selectDate: '选择日期',
    searchPlaceholderFuzzy: '请输入，支持模糊搜索',
    singlelineText: '单行文本',
    idealForShortTextSuchAsname: '适用于填写简短的文字，如“姓名”',
    multilineText: '多行文本',
    applicableToFill: '适用于填写大段的文字，如“备注”、“建议”',
    theIncreasingNumber: '自增编号',
    theSystemAutomatically: '系统按照规则自动生成编码，不可修改',
    theRadio: '单选',
    applicableToChoosing: '适用于在几个选项里选一个',
    multiselect: '多选',
    suitableForSelecting: '适用于在几个选项里选多个',
    booleanValue: '布尔值',
    chooseOneOf: '两个互斥选项中选一个',
    digital: '数字',
    usedToEnterAndDisplayNumbers: '用于输入和展示数字',
    thePercentage: '百分数',
    usedToEnterAndDisplayPercentages: '用于输入和展示百分数',
    theAmountOf: '金额',
    suitableForFilling: '适用于填写数字,带千分位,比如订单金额',
    theDateOf: '日期',
    usedToSelectASpecificDate: '用于选择特定日期',
    datetime: '日期时间',
    usedToSelectASpecificMoment: '用于选择特定时刻',
    startstopTime: '起止时间',
    usedToSelectADateOrTimeRange: '用于选择日期或时间范围',
    businessAddressField: '业务地址',
    addressField: '地址字段',
    businessAddressInfo: '该字段关联业务地址库中的数据，可关联库存组织和地点。',
    thisFieldIsAssociated: '该字段关联地址管理中的地址对象，使用已有地址库中的地址。',
    organization: '组织',
    usedToSelectASpecific: '用于选择公司内指定组织',
    personnel: '人员',
    usedToSelect: '用于选择公司内指定人员',
    masterslaveAssociated: '主从关联',
    findRelated: '查找关联',
    referenceFields: '引用字段',
    selectAFieldOfTheSameType: '可以选择[1:多]关联对象中1方的同类型字段作为引用字段，展示其数据。例如:在客户销售订单-回款明细，可以在回款明细中新增字段展示销售订单或客户的某个字段信息',
    administrativeAreas: '行政区域',
    integrateAllAddress: '集成国家地址库的所有地址信息，使用地址字段可以记录省，市，区/县，街道/乡镇信息。',
    thePicture: '图片',
    fileTypesAreSuitable: '文件类型适用于上传图片，作为更生动的补充信息',
    file: '文件',
    theFileTypeIsSuitable: '文件类型适用于上传文件或图片，可设定文件上传格式和最多上传文件的数量',
    generalDropdown: '通用下拉',
    generalTree: '通用树形',
    specialField: '特殊字段',
    theSampleOptions: '示例选项',
    pleaseSelectA: '请选择',
    is: '是',
    no: '否',
    pleaseSelectAnOrganization: '请选择组织',
    pleaseUpload: '请上传',
    pleaseUploadPictures: '请上传图片',
    pleaseUploadTheFile: '请上传文件',
    cantBeEmpty: '不能为空',
    pleaseEnterAMinimumValue: '请输入最小值',
    pleaseEnterTheMaximumValue: '请输入最大值',
    theMinimumCannot: '最小值不能大于最大值',
    pleaseSelectAStartDate: '请选择开始日期',
    pleaseSelectAnEndDate: '请选择结束日期',
    theStartDateCannot: '开始日期不能大于结束日期',
    pleaseSelectDepartment: '请选择部门',
    inputMultipleValues: '输入多值用英文逗号分隔',
    selectDateAndTime: '选择日期时间',
    exampleSingleLineText: '示例：单行文本',
    containedInTheField: '删除后，同时删除字段所包含的数据，且无法恢复，确认删除吗?',
    afterDisabledAny: '禁用后，任何用户将无法看到该字段及其数据，确认禁用吗？',
    exampleMultilineText: '示例：多行文本......',
    exampleAuto: '示例：Auto20200101001',
    example: '示例：2020-01-01 01:01:01',
    option: '选项1',
    exampleA: '示例：A',
    exampleABC: '示例：A,B,C',
    optionA: '选项一',
    exampleYesorNo: '示例：是(或否)',
    example100: '示例：100（或99.99）',
    exampleor: '示例：100%（或99.99%）',
    or: '100（或99.99）',
    exampleThe: '示例：2020-01-01',
    pleaseSelectTheDateAndTime: '请选择日期时间',
    exampleAdministrationDepartment: '示例：行政部',
    pleaseEnterTheNameOfThe: '请输入人员名称或工号，支持模糊搜索',
    exampleZhangSan: '示例：张三',
    exampleBeijing: '示例：北京',
    exampleMasterSlaveFields: '示例：主从字段',
    theMasterslaveRelationship: '删除后，将同时删除与主对象的主从关系，确认删除吗?',
    masterslaveRelationship: '禁用后，将同时禁用与主对象的主从关系,确认禁用吗?',
    exampleFindAField: '示例：查找字段',
    afterDeletionTheAssociation: '删除后，将同时删除与关联对象的关联关系， 确认删除吗?',
    ifDisabledTheAssociation: '禁用后，将同时禁用与关联对象的关联关系,确认禁用吗',
    ObjectMustNotBeNull: '对象不可为空',
    inputLenValidate1: '整数最大可输入10位',
    inputLenValidate2: '小数位最大可输入10位',
    inputLenValidate3: '整数最大可输入10位，小数位最大可输入10位',
    inputLenValidate4: '请输入正确的数值',
    inputPercentageLenValidate1: '整数最大可输入12位',
    inputPercentageLenValidate2: '小数位最大可输入8位',
    inputPercentageLenValidate3: '整数最大可输入12位，小数位最大可输入8位'
  },
  'en': {
    searchPlaceholderFuzzy: 'Please enter. Fuzzy search supported',
    pleaseEnter: 'Please enter',
    selectDate: 'Select date',
    singlelineText: 'Single-line text',
    idealForShortTextSuchAsname: 'Suitable for filling in short words, such as "name"',
    multilineText: 'Multiline text',
    applicableToFill: 'Suitable for filling in large paragraphs of text, such as "notes" and "suggestions"',
    theIncreasingNumber: 'Auto-increment No.',
    theSystemAutomatically: 'The system shall automatically generate the code according to the rules and cannot be modified',
    theRadio: 'Exclusive Choice',
    applicableToChoosing: 'Applicable to choosing one of several options',
    multiselect: 'Multiple choices',
    suitableForSelecting: 'Suitable for selecting more than one of several options',
    booleanValue: 'Boolean value',
    chooseOneOf: 'Choose one of the two mutually exclusive options',
    digital: 'Numbers',
    usedToEnterAndDisplayNumbers: 'Used to enter and display numbers',
    thePercentage: 'Percentages',
    usedToEnterAndDisplayPercentages: 'Used to enter and display percentages',
    theAmountOf: 'Amount',
    suitableForFilling: 'Suitable for filling in numbers, with thousandths, such as order amount',
    theDateOf: 'Date',
    usedToSelectASpecificDate: 'Used to select a specific date',
    datetime: 'Time',
    usedToSelectASpecificMoment: 'Used to select a specific time',
    startstopTime: 'From…to',
    usedToSelectADateOrTimeRange: 'Used to select a date or time range',
    businessAddressField: '业务地址',
    addressField: 'Address field',
    businessAddressInfo: '该字段关联业务地址库中的数据，可关联库存组织和地点。',
    thisFieldIsAssociated: 'This field is associated with the address object in address management, using addresses from the existing address library.',
    organization: 'Organization',
    usedToSelectASpecific: 'Used to select a specific organization within the company',
    personnel: 'personnel',
    usedToSelect: 'Used to select designated personnel within the company',
    masterslaveAssociated: 'Principal-subordinate association',
    findRelated: 'Find association',
    referenceFields: 'Reference field ',
    selectAFieldOfTheSameType: 'You can select the same type field of 1 party in the [1: multi] associated object as the reference field to display its data. For example, in the customer sales order-payback details, you can add a field to display the sales order or customer field information in the payback details.',
    administrativeAreas: 'Administrative Area',
    integrateAllAddress: 'Integrate all the address information of the national address library, and use the address field to record province, city, district / county, street / township information.',
    thePicture: 'picture',
    fileTypesAreSuitable: 'File types are suitable for uploading Images, as more vivid supplementary information',
    file: 'File',
    theFileTypeIsSuitable: 'File type is suitable for uploading files or pictures. File upload format and maximum number of uploaded files can be set',
    generalDropdown: 'General pull-down',
    generalTree: 'General tree',
    specialField: 'Special field',
    theSampleOptions: 'Sample options',
    pleaseSelectA: 'Please select ',
    is: 'Yes',
    no: 'No',
    pleaseSelectAnOrganization: 'Please select organization',
    pleaseUpload: 'Please upload',
    pleaseUploadPictures: 'Please upload pictures',
    pleaseUploadTheFile: 'Please upload the file',
    cantBeEmpty: 'The file cannot be empty',
    pleaseEnterAMinimumValue: 'Please enter the minimum value',
    pleaseEnterTheMaximumValue: 'Please enter the maximum value',
    theMinimumCannot: 'The minimum cannot be greater than the maximum',
    pleaseSelectAStartDate: 'Please select the start date',
    pleaseSelectAnEndDate: 'Please select the end date',
    theStartDateCannot: 'The start date cannot be greater than the end date',
    pleaseSelectDepartment: 'Please select department',
    inputMultipleValues: 'Enter multiple values, separated by English commas',
    selectDateAndTime: 'Select date and time',
    exampleSingleLineText: 'Example: single line text',
    containedInTheField: 'After deletion, the data contained in the field is deleted at the same time, and cannot be recovered. Confirm the deletion?',
    afterDisabledAny: 'After it is disabled, any user will not be able to see this field and its data. Confirm to disable it?',
    exampleMultilineText: 'Example: multi-line text...',
    exampleAuto: 'Example: Auto20200101001',
    example: 'Example: 2020-01-01 01:01:01',
    option: 'Option 1',
    exampleA: 'Example: A',
    exampleABC: 'Example: A, B, C',
    optionA: 'Option A',
    exampleYesorNo: 'Example: Yes (or No)',
    example100: 'Example: 100 (or 99.99)',
    exampleor: 'Example: 100% (or 99.99%)',
    or: '100 (or 99.99)',
    exampleThe: 'Example: 2020-01-01',
    pleaseSelectTheDateAndTime: 'Please select the date and time',
    exampleAdministrationDepartment: 'Example: Administration Department',
    pleaseEnterTheNameOfThe: 'Please enter the name of the person. Fuzzy search is supported',
    exampleZhangSan: 'Example: Zhang San',
    exampleBeijing: 'Example: Beijing',
    exampleMasterSlaveFields: 'Example: principal-subordinate field',
    theMasterslaveRelationship: 'When deleted, the principal-subordinate relationship with the principal object is also deleted. Confirm deletion?',
    masterslaveRelationship: 'When disabled, the principal-subordinate relationship with the principal object is also disabled. Confirm to disable it?',
    exampleFindAField: 'Example: find field',
    afterDeletionTheAssociation: 'When deleted, the association with the associated object is also deleted. Confirm deletion?',
    ifDisabledTheAssociation: 'When disabled, the association with the associated object is also disabled. Confirm to disable it?',
    ObjectMustNotBeNull: 'Object cannot be null',
    inputLenValidate1: 'An integer contains a maximum of 10 characters',
    inputLenValidate2: 'A maximum of 10 decimal digits can be entered',
    inputLenValidate3: 'An integer can enter a maximum of 10 digits, and a decimal place can enter a maximum of 10 digits',
    inputLenValidate4: 'Please enter the correct value',
    inputPercentageLenValidate1: 'An integer contains a maximum of 12 characters',
    inputPercentageLenValidate2: 'A maximum of 8 decimal digits can be entered',
    inputPercentageLenValidate3: 'You can enter a maximum of 12 digits for an integer and 8 digits for a decimal place'
  }
}
